import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  getSupplierBuyers,
  updateSupplierBuyer,
  supplierUpdateBuyerUserPermissions,
  supplierDeleteBuyerUser,
  getBuyerStatementPeriods,
  sendEmailStatementsForBuyersWithStatementId,
} from '../services/supplierBuyersService';
import { SupplierBuyersInitialState } from '../globalSlices/supplierBuyersSlice';

export const getSupplierBuyersExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'getSupplierBuyers';
  builder.addCase(getSupplierBuyers.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.loadingErrorList = [];
  });
  builder.addCase(
    getSupplierBuyers.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierBuyers = action.payload?.data;
      }
    }
  );
  builder.addCase(getSupplierBuyers.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload) {
      state.loadingErrorList = [
        ...new Set([...state.loadingErrorList, { getSupplierBuyers: action.payload }]),
      ];
    }
  });
};

export const updateSupplierBuyerExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'updateSupplierBuyer';
  builder.addCase(updateSupplierBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateSupplierBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(updateSupplierBuyer.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const supplierUpdateBuyerUserPermissionsExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'supplierUpdateBuyerUserPermissions';
  builder.addCase(supplierUpdateBuyerUserPermissions.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    supplierUpdateBuyerUserPermissions.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(
    supplierUpdateBuyerUserPermissions.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const supplierDeleteBuyerUserExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'supplierDeleteBuyerUser';
  builder.addCase(supplierDeleteBuyerUser.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(supplierDeleteBuyerUser.fulfilled, (state, action: PayloadAction<any | null>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(supplierDeleteBuyerUser.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getBuyerStatementPeriodsExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'getBuyerStatementPeriods';
  builder.addCase(getBuyerStatementPeriods.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getBuyerStatementPeriods.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload?.success && action.payload?.data?.statementPeriods) {
        state.statementPeriods = action.payload.data.statementPeriods;
      }
    }
  );
  builder.addCase(getBuyerStatementPeriods.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const sendEmailStatementsForBuyersWithStatementIdExtraReducer = (
  builder: ActionReducerMapBuilder<SupplierBuyersInitialState>
) => {
  const reducerId = 'sendEmailStatementsForBuyersWithStatementId';
  builder.addCase(sendEmailStatementsForBuyersWithStatementId.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    sendEmailStatementsForBuyersWithStatementId.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(
    sendEmailStatementsForBuyersWithStatementId.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};
